var _circle, _circle2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g2, _path35, _path36, _path37, _path38, _path39, _g3, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1947,
    height: 1947,
    viewBox: "0 0 1947 1947",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 973.426,
    cy: 973.442,
    r: 837.419,
    fill: "url(#paint0_linear_1919_1149)",
    stroke: "#FFDCA3",
    strokeWidth: 56
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1919_1149",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 164,
    width: 1619,
    height: 1619
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 973.426,
    cy: 973.442,
    r: 809.419,
    fill: "url(#paint1_linear_1919_1149)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1919_1149)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1661.03,
    cy: 978.245,
    r: 2.37752,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 903.236,
    cy: 952.793,
    r: 1.35917,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1210.85,
    cy: 1107.42,
    r: 1.47682,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854.612,
    cy: 725.198,
    r: 1.50483,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1107.86,
    cy: 1475.75,
    r: 1.48975,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1687.1,
    cy: 1263.34,
    r: 1.335,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.385,
    cy: 1584.65,
    r: 1.63464,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1494.75,
    cy: 683.186,
    r: 1.6863,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.813,
    cy: 405.881,
    r: 2.36862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.695,
    cy: 1718.62,
    r: 1.37614,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.995,
    cy: 1244.79,
    r: 2.44838,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 848.698,
    cy: 741.978,
    r: 1.28016,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1240.32,
    cy: 1568.55,
    r: 1.32249,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1631.95,
    cy: 1415.71,
    r: 1.43344,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 827.202,
    cy: 767.733,
    r: 1.74224,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1147.43,
    cy: 1506.92,
    r: 1.984,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1227.91,
    cy: 1430.04,
    r: 1.48457,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844.55,
    cy: 1089.16,
    r: 1.55597,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.616,
    cy: 392.574,
    r: 2.24563,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1085.3,
    cy: 443.45,
    r: 1.42763,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.723,
    cy: 739.35,
    r: 1.60579,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1311.88,
    cy: 1733.76,
    r: 1.7545,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1614.86,
    cy: 1162.08,
    r: 2.08452,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928.537,
    cy: 1740.01,
    r: 1.80048,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 703.292,
    cy: 640.99,
    r: 1.83998,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1222.08,
    cy: 1120.8,
    r: 1.43013,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.081,
    cy: 1269.15,
    r: 2.2146,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538.932,
    cy: 1402.97,
    r: 1.42828,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038.31,
    cy: 462.274,
    r: 1.90884,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1561.13,
    cy: 859.531,
    r: 1.81994,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.075,
    cy: 290.135,
    r: 2.47911,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.119,
    cy: 1146.42,
    r: 1.80767,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626.064,
    cy: 692.675,
    r: 1.99473,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.078,
    cy: 1025.89,
    r: 1.66013,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393,
    cy: 955.383,
    r: 1.83915,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1684.15,
    cy: 991.79,
    r: 2.36828,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.646,
    cy: 1763.72,
    r: 2.05385,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 799.192,
    cy: 452.832,
    r: 1.46012,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1682.28,
    cy: 340.409,
    r: 1.77669,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1487.02,
    cy: 1706.36,
    r: 1.89938,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.355,
    cy: 573.906,
    r: 2.04614,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746.873,
    cy: 1532.05,
    r: 1.9871,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1612.02,
    cy: 706.825,
    r: 1.26982,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.1,
    cy: 237.952,
    r: 2.25717,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 684.428,
    cy: 335.916,
    r: 2.36036,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1238.96,
    cy: 730.121,
    r: 2.51395,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1677.87,
    cy: 1175.41,
    r: 2.14253,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1557.67,
    cy: 1322.38,
    r: 1.59446,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1609.1,
    cy: 1014.97,
    r: 1.76541,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667.28,
    cy: 901.78,
    r: 1.68773,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126.19,
    cy: 471.245,
    r: 2.29359,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.745,
    cy: 520.12,
    r: 2.4393,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1746.63,
    cy: 816.395,
    r: 1.77045,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1495.23,
    cy: 551.748,
    r: 2.00419,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1427.3,
    cy: 1409.39,
    r: 1.84793,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 747.231,
    cy: 1029.8,
    r: 1.46792,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1621.11,
    cy: 1330.65,
    r: 1.79546,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.61,
    cy: 1554.28,
    r: 1.81707,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1211.37,
    cy: 824.283,
    r: 2.25809,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.167,
    cy: 959.206,
    r: 1.58989,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 847.112,
    cy: 770.35,
    r: 1.61954,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806.207,
    cy: 368.766,
    r: 1.46245,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1625.75,
    cy: 1208.93,
    r: 1.79743,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1411.9,
    cy: 1120.91,
    r: 1.64074,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1695.2,
    cy: 816.949,
    r: 2.1884,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1245.48,
    cy: 1166.26,
    r: 2.45924,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1314.61,
    cy: 1294.4,
    r: 1.29744,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1657.93,
    cy: 317.441,
    r: 1.31766,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.726,
    cy: 310.681,
    r: 2.20911,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1123.19,
    cy: 930.436,
    r: 1.71244,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1299.85,
    cy: 1104.5,
    r: 2.22855,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.68,
    cy: 1657.68,
    r: 1.56478,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.3,
    cy: 742.255,
    r: 1.50261,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1289.16,
    cy: 1419.87,
    r: 1.58633,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698.885,
    cy: 1548.3,
    r: 2.13826,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1254.51,
    cy: 462.433,
    r: 1.29829,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1377.64,
    cy: 1282.61,
    r: 2.46329,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.43,
    cy: 688.744,
    r: 2.13025,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756.804,
    cy: 464.802,
    r: 2.02212,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.433,
    cy: 1741.81,
    r: 1.93431,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.956,
    cy: 969.092,
    r: 1.5654,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880.536,
    cy: 1326.59,
    r: 1.82106,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.745,
    cy: 554.813,
    r: 2.30223,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1008.88,
    cy: 688.94,
    r: 1.70898,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.843,
    cy: 524.909,
    r: 2.47483,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1659.14,
    cy: 1168.74,
    r: 2.28783,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.249,
    cy: 349.207,
    r: 1.79182,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.322,
    cy: 490.123,
    r: 2.02044,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.541,
    cy: 1537.84,
    r: 1.85546,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.923,
    cy: 835.333,
    r: 1.96262,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1300.97,
    cy: 1039.01,
    r: 2.25007,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 979.841,
    cy: 528.076,
    r: 1.56668,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1554.06,
    cy: 628.709,
    r: 2.18313,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.805,
    cy: 499.605,
    r: 2.12455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.796,
    cy: 682.555,
    r: 1.71349,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235.31,
    cy: 1595.81,
    r: 2.26548,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1704.38,
    cy: 1277.12,
    r: 2.1143,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1347.84,
    cy: 418.699,
    r: 1.70661,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1195.93,
    cy: 1738.02,
    r: 2.39916,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706.268,
    cy: 1752.76,
    r: 2.09449,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 911.71,
    cy: 1461.8,
    r: 1.62641,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1252.12,
    cy: 1432.96,
    r: 2.48224,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1464.42,
    cy: 1182.71,
    r: 2.40394,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.739,
    cy: 698.542,
    r: 2.15229,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.395,
    cy: 456.241,
    r: 2.2343,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.433,
    cy: 654.515,
    r: 1.75017,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.688,
    cy: 489.582,
    r: 2.49275,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1413.65,
    cy: 749.564,
    r: 1.97408,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1009.41,
    cy: 491.833,
    r: 1.79261,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 766.967,
    cy: 1230.14,
    r: 2.20719,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.839,
    cy: 599.043,
    r: 2.32912,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1483.69,
    cy: 976.938,
    r: 2.306,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.265,
    cy: 656.181,
    r: 2.14331,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1113.39,
    cy: 889.062,
    r: 2.30303,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180.5,
    cy: 1176,
    r: 1.7698,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1143.22,
    cy: 1211.79,
    r: 2.14341,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1725.97,
    cy: 1710.4,
    r: 1.47408,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.063,
    cy: 548.329,
    r: 1.5748,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 729.396,
    cy: 1730.53,
    r: 2.43772,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.356,
    cy: 462.155,
    r: 1.4975,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.975,
    cy: 1705.57,
    r: 2.30324,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1371.64,
    cy: 1712.38,
    r: 2.27985,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1559.88,
    cy: 1191.41,
    r: 1.78796,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.679,
    cy: 1276.99,
    r: 1.53031,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1628,
    cy: 220.91,
    r: 1.78159,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1029.51,
    cy: 339,
    r: 2.39594,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 760.748,
    cy: 1566.85,
    r: 1.85223,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1016.54,
    cy: 1749.89,
    r: 2.50521,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1277,
    cy: 935.404,
    r: 1.27935,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1271.57,
    cy: 712.602,
    r: 1.71564,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 702.969,
    cy: 1416.87,
    r: 1.53088,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1754.7,
    cy: 1368.32,
    r: 2.31568,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.244,
    cy: 659.511,
    r: 1.51355,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1608.76,
    cy: 779.003,
    r: 2.30862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.721,
    cy: 1582.76,
    r: 1.60923,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1312.33,
    cy: 238.287,
    r: 1.52412,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1640.58,
    cy: 237.183,
    r: 2.33606,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 661.185,
    cy: 662.035,
    r: 1.88263,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868.227,
    cy: 1077.42,
    r: 2.17955,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.226,
    cy: 1431.7,
    r: 1.95185,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.987,
    cy: 1024.03,
    r: 1.84434,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1304.7,
    cy: 750.291,
    r: 2.00834,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1259.03,
    cy: 1429.06,
    r: 1.96667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.717,
    cy: 527.344,
    r: 1.68965,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.494,
    cy: 1203.77,
    r: 2.47823,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1626.05,
    cy: 1392.53,
    r: 1.2938,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.367,
    cy: 611.407,
    r: 2.30559,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 712.771,
    cy: 1601.89,
    r: 1.39223,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630.887,
    cy: 614.799,
    r: 1.50718,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1292.68,
    cy: 1472.87,
    r: 1.92205,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1684.28,
    cy: 499.382,
    r: 1.95176,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.62,
    cy: 1511.24,
    r: 1.86861,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1391.75,
    cy: 1416.14,
    r: 1.74072,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.14,
    cy: 1250.69,
    r: 2.03227,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.944,
    cy: 1577.74,
    r: 2.10611,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 718.777,
    cy: 685.91,
    r: 1.40511,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1709.25,
    cy: 305.55,
    r: 1.87072,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1449.78,
    cy: 546.524,
    r: 1.47201,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.915,
    cy: 1098.58,
    r: 2.38278,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 823.994,
    cy: 324.218,
    r: 1.80773,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.993,
    cy: 553.1,
    r: 1.80552,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.829,
    cy: 944.288,
    r: 2.22811,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1487.72,
    cy: 517.535,
    r: 2.04281,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855.558,
    cy: 770.517,
    r: 2.32859,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.84,
    cy: 779.473,
    r: 1.64392,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978.351,
    cy: 1335.16,
    r: 2.40875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.193,
    cy: 1042.11,
    r: 1.2747,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 616.168,
    cy: 1529.04,
    r: 2.19886,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 563.143,
    cy: 881.133,
    r: 2.36222,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1633.97,
    cy: 1268.84,
    r: 2.02017,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652.796,
    cy: 1409.07,
    r: 2.34702,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1755.49,
    cy: 348.561,
    r: 2.07511,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1782.07,
    cy: 783.229,
    r: 1.32655,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.977,
    cy: 1679.64,
    r: 1.8232,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1676.81,
    cy: 483.502,
    r: 1.41666,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1010.15,
    cy: 1096.49,
    r: 2.3929,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1379.18,
    cy: 1074.07,
    r: 1.34029,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 871.999,
    cy: 476.007,
    r: 1.96122,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1152.14,
    cy: 788.332,
    r: 2.0778,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1514.67,
    cy: 845.501,
    r: 1.90701,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.152,
    cy: 1024.94,
    r: 2.4607,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1780.01,
    cy: 1342.95,
    r: 1.27688,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1267.95,
    cy: 664.727,
    r: 1.94903,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.679,
    cy: 1175.18,
    r: 1.91502,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1575.14,
    cy: 693.122,
    r: 1.81998,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1046.07,
    cy: 274.285,
    r: 1.85869,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.282,
    cy: 663.828,
    r: 1.8517,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.322,
    cy: 1509.08,
    r: 2.21495,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.583,
    cy: 1634.83,
    r: 2.26698,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1699.34,
    cy: 1083.98,
    r: 2.2578,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950.503,
    cy: 1764.83,
    r: 2.44216,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 695.399,
    cy: 1613.1,
    r: 2.5125,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1379.19,
    cy: 637.388,
    r: 1.29333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1280.88,
    cy: 1769.8,
    r: 1.84355,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.149,
    cy: 655.162,
    r: 1.4503,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.979,
    cy: 1364.05,
    r: 1.7911,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.721,
    cy: 1099.86,
    r: 1.7917,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1397.54,
    cy: 1750.42,
    r: 1.57849,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.086,
    cy: 796.42,
    r: 1.35701,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260.43,
    cy: 1576.16,
    r: 2.0616,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1757.53,
    cy: 488.772,
    r: 1.52337,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1049.63,
    cy: 453.594,
    r: 2.38947,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.246,
    cy: 456.645,
    r: 1.62158,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.366,
    cy: 1238.73,
    r: 2.30919,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1530,
    cy: 250.103,
    r: 1.27321,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.069,
    cy: 664.55,
    r: 1.65646,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.978,
    cy: 758.588,
    r: 1.32063,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1402.71,
    cy: 470.506,
    r: 1.66727,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.213,
    cy: 845.661,
    r: 2.18708,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.277,
    cy: 1687.42,
    r: 1.97601,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.269,
    cy: 941.048,
    r: 1.79448,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 903.525,
    cy: 833.373,
    r: 1.65498,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 596.178,
    cy: 784.669,
    r: 1.76889,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020.97,
    cy: 1047.25,
    r: 2.2017,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 965.677,
    cy: 379.903,
    r: 1.47617,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 694.385,
    cy: 1121.58,
    r: 1.61513,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1071.62,
    cy: 968.426,
    r: 2.31183,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.231,
    cy: 1596.79,
    r: 1.60476,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1511.2,
    cy: 788.1,
    r: 2.20692,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1112.68,
    cy: 1523.15,
    r: 2.2851,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689.514,
    cy: 1487.24,
    r: 1.53627,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1576.09,
    cy: 609.211,
    r: 1.44932,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.546,
    cy: 272.648,
    r: 2.34118,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.159,
    cy: 521.888,
    r: 1.53228,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800.021,
    cy: 1245.73,
    r: 1.68289,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.32,
    cy: 714.524,
    r: 2.33821,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.836,
    cy: 956.638,
    r: 2.06604,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.913,
    cy: 831.064,
    r: 1.95255,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1396.85,
    cy: 624.195,
    r: 1.39223,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1011.57,
    cy: 587.647,
    r: 2.33026,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1413.93,
    cy: 382.009,
    r: 2.33309,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1431.79,
    cy: 452.949,
    r: 2.40898,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.845,
    cy: 1610.76,
    r: 1.8035,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914.768,
    cy: 1399.82,
    r: 2.33966,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.306,
    cy: 642.659,
    r: 1.99801,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1407.42,
    cy: 1400.59,
    r: 1.66411,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1265.99,
    cy: 931.719,
    r: 2.07384,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1776.51,
    cy: 438.648,
    r: 2.11781,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.497,
    cy: 355.677,
    r: 2.22961,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1073.81,
    cy: 424.345,
    r: 1.38158,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1245.47,
    cy: 732.057,
    r: 1.60661,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1218.51,
    cy: 423.354,
    r: 1.9883,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1549.01,
    cy: 955.809,
    r: 1.4476,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1419.02,
    cy: 1595.67,
    r: 2.28947,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 723.201,
    cy: 586.899,
    r: 1.66361,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 768.358,
    cy: 844.791,
    r: 2.24426,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1243.22,
    cy: 1108.86,
    r: 1.59351,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.542,
    cy: 960.191,
    r: 1.28602,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1615.3,
    cy: 391.583,
    r: 1.33373,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1509.27,
    cy: 222.909,
    r: 1.40479,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1248.67,
    cy: 1484.86,
    r: 1.59219,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1054.4,
    cy: 222.761,
    r: 2.4476,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.883,
    cy: 624.442,
    r: 2.36126,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.794,
    cy: 1609.28,
    r: 1.65563,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1071.56,
    cy: 259.314,
    r: 2.42242,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 638.265,
    cy: 1308.69,
    r: 1.42888,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 793.201,
    cy: 902.972,
    r: 1.88774,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117.99,
    cy: 884.897,
    r: 1.29053,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.357,
    cy: 560.96,
    r: 2.50123,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1256.02,
    cy: 371.296,
    r: 1.4044,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788.961,
    cy: 339.278,
    r: 1.84447,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.753,
    cy: 1314.28,
    r: 2.29518,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1507.01,
    cy: 724.009,
    r: 1.3064,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 694.802,
    cy: 1143.52,
    r: 2.31195,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.56,
    cy: 1257.45,
    r: 1.70254,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.109,
    cy: 1429.02,
    r: 1.73476,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1313.12,
    cy: 959.603,
    r: 2.37678,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1104.3,
    cy: 1449.89,
    r: 2.36252,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.672,
    cy: 389.175,
    r: 1.6961,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1052.19,
    cy: 1023.11,
    r: 2.09699,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1211.16,
    cy: 1341.81,
    r: 1.50874,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.837,
    cy: 902.199,
    r: 1.77115,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743.433,
    cy: 930.557,
    r: 1.55233,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290.49,
    cy: 239.212,
    r: 1.78011,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1568.56,
    cy: 1711.11,
    r: 1.41439,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.395,
    cy: 1079.95,
    r: 2.28451,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.699,
    cy: 262.72,
    r: 2.37044,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 768.723,
    cy: 613.991,
    r: 1.66966,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1013.43,
    cy: 1461.75,
    r: 2.26691,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1173.93,
    cy: 514.095,
    r: 1.61554,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.98,
    cy: 365.404,
    r: 2.14683,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1504.76,
    cy: 1649.54,
    r: 1.4571,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1323.36,
    cy: 1704.69,
    r: 1.64587,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 779.255,
    cy: 318.082,
    r: 2.1797,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1306.8,
    cy: 608.016,
    r: 2.16229,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.325,
    cy: 613.472,
    r: 1.84222,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1394.11,
    cy: 357.745,
    r: 1.32807,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.895,
    cy: 605.727,
    r: 1.45459,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.957,
    cy: 1110.79,
    r: 2.23988,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.344,
    cy: 1236.74,
    r: 2.20813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940.695,
    cy: 1103.72,
    r: 1.48268,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675.605,
    cy: 1339.84,
    r: 1.53246,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1179.38,
    cy: 981.764,
    r: 2.17895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.856,
    cy: 1666.41,
    r: 2.10951,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.172,
    cy: 370.852,
    r: 1.5015,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.01,
    cy: 1479.4,
    r: 1.64167,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1380.14,
    cy: 427.642,
    r: 2.29538,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1005.63,
    cy: 1775.7,
    r: 1.97611,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1507.04,
    cy: 1002.1,
    r: 2.01195,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.401,
    cy: 907.114,
    r: 1.86889,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1089.69,
    cy: 1330.83,
    r: 1.7254,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1494.54,
    cy: 1234.02,
    r: 1.83781,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1592.63,
    cy: 453.796,
    r: 1.69227,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.413,
    cy: 419.276,
    r: 1.89247,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.755,
    cy: 1297.63,
    r: 1.71088,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 851.955,
    cy: 985.293,
    r: 1.4936,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.89,
    cy: 368.875,
    r: 1.36663,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882.943,
    cy: 1583.36,
    r: 1.47814,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1538.58,
    cy: 1559.2,
    r: 2.37231,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778.424,
    cy: 899.497,
    r: 2.507,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.218,
    cy: 997.403,
    r: 1.72538,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630.423,
    cy: 830.281,
    r: 1.93947,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.092,
    cy: 1435.25,
    r: 2.11379,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.672,
    cy: 524.752,
    r: 1.52648,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.664,
    cy: 418.932,
    r: 1.97785,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1522.97,
    cy: 323.834,
    r: 2.10822,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.177,
    cy: 1485.62,
    r: 2.14219,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.284,
    cy: 1125.51,
    r: 1.54669,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832.076,
    cy: 279.391,
    r: 2.15754,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.36,
    cy: 1347.26,
    r: 1.31864,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.286,
    cy: 644.239,
    r: 1.41766,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 734.321,
    cy: 1178.78,
    r: 2.03491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1552.85,
    cy: 1438.99,
    r: 2.0853,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 768.231,
    cy: 475.51,
    r: 2.31546,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750.556,
    cy: 898.083,
    r: 1.47755,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1177.71,
    cy: 298.452,
    r: 1.29609,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1114.4,
    cy: 1181.54,
    r: 2.2681,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1093.02,
    cy: 1758.2,
    r: 1.60602,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952.214,
    cy: 1135.1,
    r: 1.68384,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1588.43,
    cy: 765.494,
    r: 1.96623,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1590.07,
    cy: 664.536,
    r: 1.58113,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1025.66,
    cy: 393.317,
    r: 1.55656,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1152.07,
    cy: 1622.06,
    r: 1.42532,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1390.25,
    cy: 376.689,
    r: 1.57407,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1274.93,
    cy: 1337.17,
    r: 1.37042,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1725.85,
    cy: 931.319,
    r: 2.02335,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1531.27,
    cy: 765.268,
    r: 1.81529,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.569,
    cy: 1542.1,
    r: 2.16734,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.379,
    cy: 1456.78,
    r: 1.57472,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.615,
    cy: 748.55,
    r: 1.9394,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1217.46,
    cy: 818.724,
    r: 2.30673,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750.436,
    cy: 883.36,
    r: 2.26407,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.945,
    cy: 586.453,
    r: 2.39513,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 793.726,
    cy: 1090.33,
    r: 1.38736,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1731.45,
    cy: 1173.7,
    r: 1.64888,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1383.35,
    cy: 963.637,
    r: 2.37727,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1423.2,
    cy: 1224.35,
    r: 2.19336,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1781.21,
    cy: 1374.21,
    r: 2.37019,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.932,
    cy: 786.863,
    r: 1.5697,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.487,
    cy: 805.905,
    r: 2.51827,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1555.66,
    cy: 250.793,
    r: 1.83545,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1552.05,
    cy: 954.282,
    r: 2.46187,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1641.81,
    cy: 1039.91,
    r: 1.36205,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 816.167,
    cy: 1130.04,
    r: 2.11185,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.41,
    cy: 1188.93,
    r: 1.69324,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1749.43,
    cy: 703.928,
    r: 1.68249,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 865.953,
    cy: 1475.86,
    r: 1.28989,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.602,
    cy: 1058.46,
    r: 1.56026,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1430.71,
    cy: 1543.91,
    r: 1.41642,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.5,
    cy: 282.576,
    r: 1.63413,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1768.81,
    cy: 646.419,
    r: 1.95965,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.635,
    cy: 1508.13,
    r: 2.39651,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.426,
    cy: 774.626,
    r: 2.37004,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800.21,
    cy: 1615.69,
    r: 1.41926,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.913,
    cy: 1284.4,
    r: 1.88083,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 879.872,
    cy: 256.946,
    r: 2.16508,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.964,
    cy: 1253.82,
    r: 1.30567,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1463.17,
    cy: 795.99,
    r: 2.19972,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.136,
    cy: 727.892,
    r: 1.98782,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 955.881,
    cy: 1362.06,
    r: 2.4969,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1738.05,
    cy: 584.779,
    r: 2.30244,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.327,
    cy: 719.72,
    r: 1.81863,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1688.86,
    cy: 1733.72,
    r: 2.05222,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1100.79,
    cy: 722.147,
    r: 1.71508,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675.996,
    cy: 764.872,
    r: 1.27174,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1589.79,
    cy: 698.491,
    r: 1.54349,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1377.34,
    cy: 1404.55,
    r: 1.43232,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755.893,
    cy: 772.849,
    r: 2.24069,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.503,
    cy: 803.557,
    r: 1.46456,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 943.726,
    cy: 824.839,
    r: 1.56007,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.269,
    cy: 1455.05,
    r: 2.06764,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.589,
    cy: 1366.64,
    r: 1.31346,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.812,
    cy: 464.094,
    r: 1.85751,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.147 898.419C460.147 913.568 455.786 928.717 436.162 928.717C455.786 928.717 460.147 946.029 460.147 959.014C460.147 946.029 464.508 928.717 484.133 928.717C464.508 928.717 460.147 913.568 460.147 898.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.95 1049.91C1560.95 1065.06 1556.59 1080.21 1536.97 1080.21C1556.59 1080.21 1560.95 1097.52 1560.95 1110.5C1560.95 1097.52 1565.32 1080.21 1584.94 1080.21C1565.32 1080.21 1560.95 1065.06 1560.95 1049.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.336 669.817C337.336 684.966 332.975 700.115 313.35 700.115C332.975 700.115 337.336 717.427 337.336 730.412C337.336 717.427 341.697 700.115 361.321 700.115C341.697 700.115 337.336 684.966 337.336 669.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.203 398.513C975.203 407.349 972.678 416.186 961.317 416.186C972.678 416.186 975.203 426.285 975.203 433.86C975.203 426.285 977.728 416.186 989.089 416.186C977.728 416.186 975.203 407.349 975.203 398.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311 464.157C1311 472.994 1308.48 481.831 1297.11 481.831C1308.48 481.831 1311 491.93 1311 499.504C1311 491.93 1313.52 481.831 1324.89 481.831C1313.52 481.831 1311 472.994 1311 464.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.57 772.181C1674.57 781.018 1672.04 789.854 1660.68 789.854C1672.04 789.854 1674.57 799.954 1674.57 807.528C1674.57 799.954 1677.09 789.854 1688.45 789.854C1677.09 789.854 1674.57 781.018 1674.57 772.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1653.11,
    cy: 1224.12,
    r: 5.04957,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1423.35,
    cy: 1327.63,
    r: 5.04957,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.439,
    cy: 989.313,
    r: 5.04957,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.05,
    cy: 547.475,
    r: 5.04957,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.225,
    cy: 1217.23,
    r: 5.04957,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 933.987,
    cy: 853.848,
    r: 5.04957,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.759,
    cy: 512.128,
    r: 5.04957,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.23 935.578C1047.23 944.414 1044.71 953.251 1033.34 953.251C1044.71 953.251 1047.23 963.35 1047.23 970.925C1047.23 963.35 1049.75 953.251 1061.12 953.251C1049.75 953.251 1047.23 944.414 1047.23 935.578Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.49,
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M594.975 599.257C617.527 561.771 659.272 599.257 650.155 618.28C684.703 605.747 708.694 619.959 687.582 633.946C666.47 647.934 32.7101 682.588 31.1781 618.28C30.7943 602.166 57.2487 602.614 70.524 604.852C84.7269 579.787 106.511 584.337 115.628 589.746C130.215 543.195 160.092 558.414 173.207 571.842C163.77 534.728 173.207 428.61 290.765 428.609C409.492 428.609 432.794 499.293 417.919 553.938C453.906 500.226 504.288 513.467 527.32 561.211C574.823 550.581 594.975 572.401 594.975 599.257Z",
    fill: "url(#paint2_linear_1919_1149)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.49,
    style: {
      mixBlendMode: "screen"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1821.36 1490.84C1845.67 1460.57 1890.66 1490.84 1880.83 1506.2C1918.06 1496.08 1943.92 1507.55 1921.17 1518.85C1898.41 1530.14 1215.37 1558.13 1213.72 1506.2C1213.3 1493.19 1241.82 1493.55 1256.12 1495.36C1271.43 1475.12 1294.91 1478.79 1304.74 1483.16C1320.46 1445.57 1352.66 1457.86 1366.79 1468.7C1356.62 1438.73 1366.79 1353.04 1493.49 1353.04C1621.45 1353.04 1646.57 1410.12 1630.53 1454.24C1669.32 1410.87 1723.62 1421.56 1748.44 1460.12C1799.64 1451.53 1821.36 1469.15 1821.36 1490.84Z",
    fill: "url(#paint3_linear_1919_1149)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.65 564.127C1537.29 519.702 1472.38 552.185 1472.38 574.875C1462.23 569.8 1455.37 564.127 1436.56 579.951C1433.29 582.703 1436.56 590.997 1436.56 590.997C1442.65 597.227 1576.26 603.08 1614.5 590.997C1614.5 558.455 1577.18 555.768 1561.65 564.127Z",
    fill: "url(#paint4_linear_1919_1149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M479.808 1132.35C537.796 1138.13 561.537 1196.33 561.537 1221.11C622.38 1194.96 668.575 1221.11 668.575 1278.9C683.597 1255.23 718.419 1259.18 721.674 1278.9C777.86 1245.32 800.419 1284.64 815.191 1306.78C869.774 1298.06 969.4 1296.66 931.242 1360.79C893.084 1424.92 775.631 1393.47 721.674 1369.73C649.866 1445.15 503.719 1401.16 439.622 1369.73C381.634 1413.22 262.979 1398.18 210.9 1385.22C176.348 1409.64 70.062 1390.72 49.0301 1360.79C32.2046 1336.84 75.0696 1326.5 98.6053 1324.32C113.928 1296.52 141.796 1312.74 153.814 1324.32C164.33 1282.49 196.253 1295.19 210.9 1306.78C253.565 1236.87 297.281 1277.65 313.806 1306.78C315.183 1293.36 320.942 1257.44 332.96 1221.11C347.983 1175.7 407.323 1125.12 479.808 1132.35Z",
    fill: "url(#paint5_linear_1919_1149)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.284 974.794L278.467 973.088L277.794 939.495L297.59 939.099L299.422 1030.58L279.626 1030.98L278.953 997.384L193.77 999.089L193.284 974.794ZM200.72 1086.03C199.38 1076.92 199.981 1068.65 202.523 1061.2C205.079 1053.85 209.148 1047.84 214.728 1043.18C220.407 1038.5 227.204 1035.58 235.119 1034.42C243.132 1033.24 250.476 1034.02 257.148 1036.78C263.935 1039.62 269.533 1044 273.942 1049.93C278.451 1055.83 281.302 1062.84 282.497 1070.95C283.647 1078.77 283 1086.04 280.554 1092.77C278.221 1099.58 274.208 1105.28 268.514 1109.86C262.919 1114.42 255.818 1117.33 247.211 1118.6C246.321 1118.73 245.275 1118.84 244.073 1118.91C242.97 1118.97 241.917 1119.03 240.913 1119.07L231.364 1054.22L244.869 1052.24L252.625 1104.92L247.308 1096.6C251.463 1095.99 254.95 1094.62 257.769 1092.49C260.589 1090.35 262.621 1087.68 263.866 1084.46C265.209 1081.23 265.59 1077.64 265.007 1073.68C264.425 1069.72 263.017 1066.34 260.785 1063.54C258.666 1060.82 255.9 1058.85 252.486 1057.63C249.172 1056.4 245.387 1056.1 241.133 1056.73L237.572 1057.25C233.218 1057.89 229.498 1059.4 226.411 1061.78C223.438 1064.23 221.316 1067.33 220.045 1071.05C218.887 1074.86 218.658 1079.14 219.357 1083.89C219.984 1088.14 221.173 1091.76 222.925 1094.73C224.692 1097.81 227.058 1100.49 230.024 1102.79L218.482 1117.07C213.787 1114.02 209.895 1109.89 206.803 1104.69C203.811 1099.47 201.783 1093.25 200.72 1086.03ZM225.941 1195.32L241.093 1191.02L244.003 1188.63L271.132 1180.94C275.942 1179.57 279.271 1177.02 281.119 1173.27C282.993 1169.62 283.071 1164.76 281.352 1158.7C280.178 1154.57 278.345 1150.67 275.851 1147.01C273.482 1143.42 270.795 1140.54 267.791 1138.38L281.227 1125.84C285.411 1129.23 289.166 1133.67 292.494 1139.17C295.821 1144.67 298.358 1150.5 300.105 1156.66C303.462 1168.49 303.279 1178.47 299.555 1186.59C295.831 1194.72 288.053 1200.46 276.22 1203.82L231.918 1216.38L225.941 1195.32ZM218.072 1171.98C216.353 1165.92 215.889 1160.43 216.681 1155.53C217.569 1150.6 219.466 1146.48 222.37 1143.16C225.275 1139.84 228.94 1137.55 233.365 1136.3C237.983 1134.99 242.337 1134.95 246.428 1136.18C250.547 1137.5 254.264 1140.35 257.58 1144.71C260.992 1149.04 263.817 1155.15 266.055 1163.04L271.91 1183.68L258.778 1187.4L253.62 1169.22C252.118 1163.93 250.215 1160.52 247.911 1158.99C245.633 1157.56 243.196 1157.21 240.598 1157.95C237.712 1158.77 235.717 1160.53 234.613 1163.23C233.633 1166 233.702 1169.36 234.821 1173.31C235.885 1177.06 237.707 1180.18 240.284 1182.67C242.958 1185.13 246.218 1186.55 250.063 1186.91L240.656 1193.32C235.189 1193.11 230.543 1191.2 226.718 1187.61C222.892 1184.02 220.01 1178.81 218.072 1171.98ZM360.985 1303.58C363.768 1309.34 365.054 1314.99 364.844 1320.54C364.767 1326.13 362.951 1331.33 359.396 1336.16C355.974 1341.03 350.571 1345.25 343.187 1348.82L301.584 1368.91L291.408 1347.84L329.77 1329.31C335.623 1326.48 339.359 1323.18 340.976 1319.4C342.594 1315.62 342.337 1311.53 340.206 1307.11C338.728 1304.05 336.681 1301.65 334.066 1299.92C331.541 1298.14 328.557 1297.25 325.113 1297.25C321.669 1297.24 317.786 1298.29 313.464 1300.37L276.993 1317.98L266.818 1296.91L305.179 1278.39C311.033 1275.56 314.768 1272.26 316.386 1268.48C318.047 1264.79 317.812 1260.74 315.681 1256.33C314.202 1253.26 312.156 1250.87 309.541 1249.13C307.016 1247.35 304.032 1246.46 300.588 1246.46C297.144 1246.45 293.261 1247.5 288.938 1249.58L252.468 1267.2L242.293 1246.12L314.963 1211.03L324.682 1231.16L304.826 1240.75L308.808 1234.16C314.978 1234.29 320.433 1236.04 325.172 1239.42C330.045 1242.84 333.916 1247.52 336.786 1253.46C340.004 1260.13 341.098 1266.76 340.067 1273.37C339.171 1280.02 335.647 1285.83 329.496 1290.8L327.934 1282.39C334.782 1282.08 341.154 1283.78 347.051 1287.49C352.992 1291.28 357.637 1296.64 360.985 1303.58ZM380.196 1480.3C374.758 1474.03 370.734 1467.33 368.123 1460.2C365.577 1453.14 364.452 1446.04 364.747 1438.9C365.108 1431.84 366.832 1425.05 369.919 1418.54C373.071 1412.1 377.593 1406.32 383.486 1401.21C389.38 1396.1 395.737 1392.44 402.557 1390.23C409.444 1388.1 416.441 1387.4 423.55 1388.11C430.659 1388.83 437.526 1390.95 444.152 1394.47C450.777 1397.99 456.776 1402.85 462.148 1409.04C467.586 1415.32 471.544 1421.94 474.025 1428.92C476.571 1435.98 477.663 1443.04 477.302 1450.1C477.007 1457.24 475.316 1464.07 472.229 1470.59C469.218 1477.03 464.728 1482.85 458.759 1488.02C452.866 1493.13 446.439 1496.79 439.477 1498.98C432.59 1501.12 425.593 1501.82 418.484 1501.11C411.517 1500.4 404.72 1498.28 398.094 1494.76C391.534 1491.32 385.568 1486.5 380.196 1480.3ZM395.737 1466.63C398.816 1470.18 402.238 1472.9 406.001 1474.8C409.831 1476.78 413.861 1477.91 418.093 1478.22C422.325 1478.52 426.514 1477.93 430.66 1476.45C434.871 1475.05 438.866 1472.71 442.643 1469.44C446.421 1466.16 449.302 1462.54 451.286 1458.57C453.335 1454.67 454.511 1450.61 454.812 1446.38C455.179 1442.22 454.656 1438.11 453.245 1434.04C451.833 1429.97 449.588 1426.16 446.509 1422.61C443.43 1419.05 439.975 1416.29 436.146 1414.32C432.382 1412.42 428.384 1411.32 424.152 1411.02C419.921 1410.72 415.699 1411.27 411.488 1412.67C407.342 1414.15 403.38 1416.52 399.602 1419.8C395.9 1423.01 392.987 1426.59 390.862 1430.55C388.878 1434.52 387.702 1438.59 387.336 1442.74C387.034 1446.98 387.589 1451.13 389.001 1455.2C390.413 1459.27 392.658 1463.08 395.737 1466.63ZM437.776 1541.74L491.055 1481.12L507.842 1495.88L492.789 1513L494.78 1505.97C500.346 1503.27 506.077 1502.58 511.972 1503.9C517.933 1505.15 523.768 1508.28 529.476 1513.3L515.216 1529.52C514.531 1528.79 513.888 1528.16 513.287 1527.63C512.752 1527.02 512.147 1526.43 511.471 1525.83C506.664 1521.61 501.537 1519.56 496.09 1519.7C490.784 1519.83 485.589 1522.79 480.505 1528.57L455.351 1557.19L437.776 1541.74ZM494.393 1590.31L542.465 1525.49L561.26 1539.43L513.188 1604.25L494.393 1590.31ZM558.564 1523.43C555.11 1520.86 553.043 1517.78 552.364 1514.16C551.685 1510.54 552.447 1507.25 554.651 1504.28C556.855 1501.3 559.786 1499.62 563.444 1499.22C567.102 1498.82 570.658 1499.9 574.111 1502.46C577.565 1505.02 579.662 1508.07 580.401 1511.61C581.199 1515.06 580.497 1518.28 578.293 1521.25C575.969 1524.38 572.949 1526.19 569.232 1526.67C565.654 1527.13 562.098 1526.05 558.564 1523.43ZM572.13 1643.06C564.726 1638.69 559.055 1633.25 555.118 1626.74C551.267 1620.28 549.239 1613.39 549.035 1606.07C548.968 1598.71 550.969 1591.59 555.038 1584.7C559.159 1577.73 564.431 1572.54 570.857 1569.14C577.419 1565.7 584.432 1564.15 591.894 1564.49C599.494 1564.8 606.996 1567.14 614.4 1571.52C621.719 1575.84 627.346 1581.25 631.284 1587.76C635.272 1594.18 637.325 1601.03 637.443 1608.3C637.561 1615.57 635.534 1622.74 631.363 1629.8C627.294 1636.68 622.021 1641.87 615.545 1645.37C609.119 1648.77 602.107 1650.32 594.507 1650.01C586.907 1649.7 579.449 1647.39 572.13 1643.06ZM581.897 1626.53C585.254 1628.51 588.726 1629.52 592.31 1629.55C595.895 1629.57 599.301 1628.63 602.53 1626.7C605.809 1624.69 608.618 1621.7 610.958 1617.74C613.349 1613.69 614.609 1609.79 614.738 1606.04C614.866 1602.28 614.054 1598.84 612.301 1595.71C610.547 1592.58 607.992 1590.03 604.634 1588.05C601.276 1586.06 597.805 1585.06 594.22 1585.03C590.636 1585 587.186 1585.93 583.872 1587.8C580.644 1589.73 577.834 1592.71 575.443 1596.76C573.104 1600.72 571.844 1604.62 571.664 1608.46C571.621 1612.27 572.477 1615.74 574.23 1618.87C575.983 1621.99 578.539 1624.55 581.897 1626.53ZM710.893 1620.01C716.793 1622.49 721.543 1625.9 725.144 1630.23C728.875 1634.51 731.05 1639.66 731.669 1645.67C732.326 1651.59 731.065 1658.33 727.885 1665.88L709.972 1708.47L688.403 1699.4L704.92 1660.13C707.44 1654.14 707.965 1649.15 706.493 1645.17C705.114 1641.23 702.028 1638.25 697.235 1636.23C693.824 1634.8 690.426 1634.23 687.041 1634.55C683.786 1634.8 680.755 1636.08 677.947 1638.37C675.231 1640.7 672.904 1644.17 670.966 1648.78L655.495 1685.56L633.926 1676.48L665.215 1602.1L685.817 1610.76L677.151 1631.36L675.897 1623.51C680.664 1619.66 686.098 1617.44 692.2 1616.86C698.302 1616.28 704.533 1617.33 710.893 1620.01Z",
    fill: "url(#paint6_linear_1919_1149)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.47 1329.79C1090.69 1311.1 1044.94 1315.93 993.205 1293.31C976.453 1231.94 968.465 1119.47 1045.11 1140.95C1121.76 1162.44 1236.99 1224.78 1247.86 1248.08C1273.86 1303.78 1224.47 1345.01 1219.57 1366.63C1208.85 1401.98 1197.49 1486.27 1208.26 1546.87C1219.45 1563.53 1251.59 1621 1238.82 1632.48C1208.47 1659.78 1082.57 1623.5 1073.22 1570.86C1065.31 1526.34 1080.81 1366.6 1127.47 1329.79Z",
    fill: "#C1DBEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.63 1264.27C1052.58 1283.86 1133.67 1312.23 1157.7 1317.84C1106.03 1372.44 1081.47 1455.01 1071.56 1524.99C1074.05 1459.61 1091.5 1358.17 1127.47 1329.79C1096.98 1314.29 1060.32 1314.97 1019.2 1302.76L1011.63 1264.27Z",
    fill: "#1B47B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.99 1149.91C1078.65 1151.93 1084.41 1154.1 1090.23 1156.38C1084.75 1172.44 1075.1 1196.7 1064.93 1210.38C1049.44 1231.23 1066.51 1274.78 1132.65 1316.81C1176.02 1344.38 1004.81 1562.1 1176.64 1639.06C1131.27 1630.69 1079.11 1604.02 1073.22 1570.86C1065.31 1526.34 1080.81 1366.6 1127.47 1329.79C1098.24 1314.93 1063.35 1314.94 1024.29 1304.22L989.007 1258.42L1072.99 1149.91Z",
    fill: "#C1DBEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1082.74 1591.02C1125.4 1563.82 1182.1 1532.77 1196.04 1535.97C1199.74 1536.82 1203.58 1538.91 1207.43 1541.89C1207.69 1543.57 1207.97 1545.23 1208.26 1546.87C1211.37 1551.51 1216.1 1559.3 1221.04 1568.38C1210.04 1557.06 1199.59 1548.02 1195.1 1548.77C1187.65 1550.02 1130.69 1574.46 1086.74 1595.72C1085.32 1594.18 1083.98 1592.61 1082.74 1591.02Z",
    fill: "#CB8A4F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1213.24 1378.72C1199.66 1379.49 1175.1 1318.05 1194.42 1340.39C1203.58 1350.98 1215.68 1353.82 1225.02 1354.46C1222.36 1359.03 1220.37 1363.09 1219.57 1366.63C1218.54 1370.02 1217.5 1373.87 1216.48 1378.1C1215.41 1378.44 1214.32 1378.66 1213.24 1378.72Z",
    fill: "#CBDEEC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1264.46 1284.48C1265.72 1305.04 1257.99 1354.6 1231.59 1356.67C1225.94 1357.11 1221.93 1357.2 1213.83 1351.55C1212.08 1350.33 1201.51 1332.1 1200.29 1309.56C1199.09 1287.36 1200.57 1279.48 1206.38 1265.96C1210.68 1255.94 1228.07 1249.36 1231.79 1247.91C1253.41 1239.46 1263.21 1263.92 1264.46 1284.48Z",
    fill: "#ED8537"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M745.745 1160.69C766.155 1196.55 861.874 1194.9 907.182 1189.6L967.125 925.026L795.202 861.787C770.212 946.479 725.335 1124.83 745.745 1160.69Z",
    fill: "#FF9F56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M779.442 1140.44C799.852 1176.31 895.57 1174.66 940.878 1169.35L1000.82 904.781L828.899 841.542C803.909 926.234 759.031 1104.58 779.442 1140.44Z",
    fill: "#ED8537"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M856.249 1005.05L917.345 873.543C914.349 867.05 962.507 812.871 865.746 830.06C801.314 788.491 744.558 755.12 683.05 755.572C666.321 755.695 642.305 788.705 659.473 817.345C683.634 857.651 731.561 901.344 763.083 909.721C783.118 923.712 837.091 965.127 856.249 1005.05Z",
    fill: "#F2FBFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1215.55 922.138C1139.14 830.412 1109.93 799.954 1054.57 827.887L1030.57 908.929L1199.7 1018.18C1236.82 1024.39 1291.95 1013.86 1215.55 922.138Z",
    fill: "#C1DBEC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.12 920.125L1180.68 951.255L1183.37 1003.43C1183.37 1003.43 1212.55 1036.08 1239.86 1031.23C1255.28 1028.49 1353.7 900.228 1356.47 860.25C1379.09 867.199 1374.8 854.961 1380.29 846.147C1387.97 833.814 1341.46 766.941 1306.98 773.067C1302.88 773.794 1295.39 784.997 1299.16 806.263C1258.32 838.747 1186.12 920.125 1186.12 920.125Z",
    fill: "#C1DBEC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.06 568.023C1134.85 557.401 1099.34 576.688 1083.52 589.552C1112.65 651.124 1107.31 664.299 1105.27 711.988C1114.92 711.737 1165.36 701.561 1177.38 682.565C1186.37 668.354 1171.2 591.845 1146.06 568.023Z",
    fill: "#ED8537"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.81 892.456C1134.71 927.065 1220.67 1004.7 1230 1000.41C1232.87 999.095 1240.47 989.865 1250.5 976.663C1265.54 1018.08 1227.55 1022.84 1199.7 1018.18L1076.34 938.492L1091.81 892.456Z",
    fill: "#1D48B3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1368.26 837.101C1367.05 830.321 1372.8 833.19 1380.9 839.996C1381.33 842.628 1381.16 844.741 1380.29 846.146C1374.8 854.96 1379.09 867.198 1356.47 860.249C1353.7 900.228 1255.28 1028.49 1239.86 1031.23C1212.59 1036.08 1183.46 1003.52 1183.37 1003.43L1181.73 971.54C1206.62 989.356 1226.86 1002.16 1231.06 1000.23C1242.72 994.863 1332.62 858.787 1345.92 856.426C1359.21 854.065 1371.56 855.709 1368.26 837.101Z",
    fill: "#1D48B3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.47 824.225C1074.98 818.976 1086.23 816.986 1097.19 818.295C1118.35 830.944 1111.91 888.293 1113.24 895.779C1114 900.032 1140.97 926.487 1162.66 942.393C1208.34 975.898 1236.07 1023.19 1307.67 953.006C1279.48 993.116 1248.03 1029.78 1239.86 1031.23C1225.67 1033.75 1210.97 1026.14 1200.12 1018.25C1199.98 1018.23 1199.84 1018.21 1199.7 1018.19L1070.16 934.499L1062.47 824.225Z",
    fill: "#C1DBEC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M839.563 855.551C956.368 806.722 1076.24 803.583 1098.02 825.541C1110.05 837.664 1100.48 924.5 1077.6 991.504C1083.5 1026.59 1083.32 1100.68 1080.97 1149.4C1080.11 1167.23 1050.46 1198.27 1046.89 1216.88C1030.08 1304.52 1026.14 1348.78 1026.08 1371.39C1025.97 1408.3 1023.89 1433.2 1009.68 1448.89C999.379 1460.26 985.432 1480.05 975.803 1502.07C952.404 1555.59 939.971 1599.17 942.74 1640.12C967.529 1708.66 968.344 1713.24 957.474 1723.06C946.602 1732.87 828.45 1728.43 809.286 1654.5C802.75 1629.29 819.058 1546.45 848.944 1485.67C868.75 1445.4 893.626 1416.13 911.24 1391.79C911.179 1391.65 869.071 1295.22 855.38 1231.7C848.966 1201.95 849.719 1177.19 850.734 1152.8C847.106 1127.64 851.352 1052.13 856.875 1005.49C838.476 978.482 839.767 888.603 839.563 855.551Z",
    fill: "#F2FBFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M990.254 842.493C1002.47 870.12 1022.72 926.448 1013.87 975.405",
    stroke: "#CEDFE6",
    strokeWidth: 9.71951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M763.823 772.964C796.851 786.604 830.126 807.079 865.746 830.06C892.278 825.347 907.914 826 916.696 829.564C963.565 817.324 1007.11 812.134 1040.15 812.533C1005.73 840.361 952.241 859.154 889.549 855.995C832.336 853.112 786.826 825.655 763.823 772.964Z",
    fill: "#CBDEEC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M916.488 834.757C907.894 828.057 912.494 807.131 913.693 797.412C950.633 787.193 1026.29 769.133 1031.16 782.577C1035.46 794.427 1045.31 812.839 1037.21 816.602C1019.98 824.598 922.217 839.223 916.488 834.757Z",
    fill: "#ED8537"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M765.552 633.424C772.371 539.089 833.343 504.582 902.853 480.153C951.375 463.1 1025.14 463.852 1079.94 495.31C1134.75 526.769 1141.38 587.798 1158.04 678.509C1174.7 769.221 1041.29 806.617 919.718 811.779C798.151 816.941 758.047 737.271 765.552 633.424Z",
    fill: "#F2FBFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M863.261 680.233C864.444 597.978 930.701 551.438 1001.04 538.941C1045.7 531.008 1095.37 542.612 1118.26 575.155C1142.99 610.324 1146.88 661.827 1150.77 693.325C1158.25 753.968 1028.89 790.623 968.771 792.563C900.864 794.755 861.783 783.051 863.261 680.233Z",
    fill: "#78BFE2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M827.099 760.694C833.085 761.459 847.356 765.432 856.551 775.206C866.33 785.601 891.722 807.908 965.225 808.325C950.08 809.999 934.808 811.138 919.718 811.779C860.641 814.288 820.802 796.761 796.317 766.162L827.099 760.694Z",
    fill: "#CBDEEC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M833.149 936.761C778.389 946.489 654.793 853.065 630.886 792.26C637.55 752.44 646.322 646.737 662.303 583.212C656.462 561.858 653.429 570.301 666.5 560.53L757.857 577.755C768.304 587.307 757.228 594.631 749.749 600.035C750.477 679.723 753.28 709.821 750.151 787.526C750.151 787.526 867.892 930.589 833.149 936.761Z",
    fill: "#F2FBFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M745.879 642.565C757.561 624.972 784.996 625.561 804.272 632.192C798.133 700.029 814.144 727.896 840.518 767.795C831.377 770.881 807.39 788.706 785.639 783.028C752.766 774.448 726.72 671.417 745.879 642.565Z",
    fill: "#FF9F56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1001.04 538.941C1012.47 536.912 1024.22 536.164 1035.76 536.715C1070.22 591.26 1105.79 706.752 1045.02 779.252C1019.52 786.61 994.019 791.059 974.41 792.291C1012.63 749.505 1044.07 654.218 971.981 546.172C981.479 543.095 991.222 540.686 1001.04 538.941Z",
    fill: "#A6E8F6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.01 537.824C1056.78 538.876 1064.36 540.544 1071.57 542.838C1100.88 597.037 1126.02 695.927 1085.93 764.691C1078.9 767.776 1071.59 770.62 1064.15 773.216C1095.35 725.296 1111.08 634.522 1049.01 537.824Z",
    fill: "#A6E8F6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M937.198 562.349C923.304 564.817 905.278 515.101 843.151 507.323C841.104 507.067 840.437 504.332 842.173 503.216C905.725 462.333 926.116 463.138 965.115 466.351C985.593 468.038 1077.53 540.852 1045.09 539.892C1018.62 539.109 956.695 558.885 937.198 562.349Z",
    fill: "#FF9F56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.906 625.811C876.842 685.521 867.856 785.1 1008.96 787.445C993.992 790.235 980.107 791.852 968.71 792.22C900.803 794.412 861.723 782.707 863.201 679.889C863.219 678.641 863.251 677.402 863.299 676.171C865.122 663.095 867.851 649.076 871.479 634.132C872.53 631.296 873.675 628.523 874.906 625.811Z",
    fill: "#549BD1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M657.042 522.723C657.46 505.884 660.155 481.587 666.961 470.506L780 464.685C788.072 439.12 783.948 443.691 811.772 430.522C839.596 417.353 847.592 434.579 841.874 439.434C836.155 444.289 831.237 466.003 818.132 494.107C807.647 516.59 768.075 559.121 749.599 577.577L674.451 565.15C669.38 553.072 656.597 540.673 657.042 522.723Z",
    fill: "#ED8537"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82,
    filter: "url(#filter0_f_1919_1149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.632 610.401C837.585 436.905 865.997 445.569 453.462 512.82C859.337 420.427 836.781 444.726 814.677 261.639C851.149 426.818 910.942 414.55 1433.82 338.665C916.326 444.854 853.993 452.088 876.632 610.401Z",
    fill: "#FFDEA9"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M876.632 610.401C837.585 436.905 865.997 445.569 453.462 512.82C859.337 420.427 836.781 444.726 814.677 261.639C851.149 426.818 910.942 414.55 1433.82 338.665C916.326 444.854 853.993 452.088 876.632 610.401Z",
    fill: "#FFDEA9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M814.677 261.639C850.347 423.183 908.322 415.005 1399.98 343.581L846.693 441.868L814.677 261.639Z",
    fill: "#FFEFD4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M876.632 610.401C837.585 436.905 863.338 446.041 450.804 513.293C462.408 510.651 473.665 508.106 484.583 505.647L846.598 441.337L876.632 610.401Z",
    fill: "#F6BC7E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M719.997 540.606C716.706 506.64 748.389 494.614 766.6 481.872L679.41 497.361C691.148 499.225 712.97 522.66 719.997 540.606Z",
    fill: "#D76331"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M690.578 523.184C670.45 525.83 655.468 505.649 650.291 490.895C648.325 479.828 653.781 451.885 671.326 448.769C708.541 442.158 744.913 403.221 771.272 406.665C797.631 410.109 786.302 472.77 784.815 482.902C783.328 493.035 756.813 504.13 736.796 502.462C716.778 500.793 715.737 519.875 690.578 523.184Z",
    fill: "#FF9F56"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96,
    filter: "url(#filter1_f_1919_1149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1438.48 798.564C1480.85 1013.54 1254.35 1174.54 1254.35 1174.54C1254.35 1174.54 1423.19 1017.03 1380.82 802.052C1338.45 587.075 1132.14 486.586 1132.14 486.586C1132.14 486.586 1396.11 583.588 1438.48 798.564Z",
    fill: "#FFDEA9"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.48 798.564C1480.85 1013.54 1254.35 1174.54 1254.35 1174.54C1254.35 1174.54 1423.19 1017.03 1380.82 802.052C1338.45 587.075 1132.14 486.586 1132.14 486.586C1132.14 486.586 1396.11 583.588 1438.48 798.564Z",
    fill: "#FFDEA9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1270 1158.2C1266.7 1162.36 1263.58 1166.24 1260.65 1169.81C1256.63 1172.92 1254.36 1174.53 1254.35 1174.54C1254.37 1174.52 1260.45 1168.85 1270 1158.2ZM1229.27 553.635C1300.71 612.009 1392.21 701.779 1412.29 791.652C1432.19 880.73 1385.17 985.626 1334.79 1066.53C1371.13 1000.43 1401.75 908.256 1380.82 802.051C1358.22 687.376 1288.97 605.28 1229.27 553.635ZM1141.73 490.41C1143.49 491.14 1145.47 491.978 1147.65 492.92C1154.48 497.484 1165.53 505.056 1179.36 515.131C1164.12 504.689 1151.47 497.151 1143.11 492.453L1141.73 490.41Z",
    fill: "#F6BC7E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.21 784.172C1293.42 764.067 1325.65 756.769 1343.37 755.634L1417.32 764.433C1414.61 778.991 1426.58 816.534 1407.8 837.419C1394.24 852.504 1376.07 853.294 1366.03 849.228C1344.75 840.619 1318.99 804.276 1306.21 784.172Z",
    fill: "#ED8537"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1401.56 816.115C1401.87 816.851 1402.08 817.531 1402.18 818.126L1401.56 816.115C1398.21 808.101 1382.84 793.51 1354.06 809.673L1389.21 776.007L1401.56 816.115Z",
    fill: "#D76331"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1397.46 831.524C1409.84 847.617 1434.7 843.917 1448.79 837.133C1458 830.689 1473.88 807.058 1463.66 792.458C1441.99 761.488 1443.76 708.234 1422.67 692.051C1401.58 675.867 1365.33 728.218 1359.22 736.44C1353.12 744.661 1364.05 771.246 1379.39 784.207C1394.74 797.168 1381.99 811.409 1397.46 831.524Z",
    fill: "#FF9F56"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.83 717.568C1311.36 728.89 1290.27 776.034 1331.27 807.095C1338.22 813.166 1361.76 813.822 1374.35 792.906C1384.34 776.326 1385.14 768.505 1367.62 755.018C1381.15 755.091 1396.37 746.9 1400.9 729.126C1405.44 711.352 1348.42 703.415 1327.83 717.568Z",
    fill: "#ED8537"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.77 716.629C1304.29 727.951 1283.21 775.096 1324.2 806.156C1331.15 812.227 1349.61 820.318 1367.87 804.11C1386.13 787.901 1380.45 764.832 1360.56 754.079C1374.09 754.153 1389.3 745.961 1393.84 728.188C1398.37 710.414 1341.36 702.477 1320.77 716.629Z",
    fill: "#FF9F56"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.02 1002.06C1010.84 1041.75 1017.82 1121.13 1014.93 1166.62",
    stroke: "#CEDFE6",
    strokeWidth: 9.71951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M813.995 1667.58C858.368 1646.22 913.978 1623.41 926.94 1628.35C932.865 1630.61 938.688 1636.39 944.092 1643.87C948.653 1656.5 952.35 1666.84 955.267 1675.39C943.543 1658.11 930.102 1640.74 924.232 1640.9C916.884 1641.1 861.815 1657.87 817.024 1673.35C815.939 1671.48 814.927 1669.56 813.995 1667.58Z",
    fill: "#FF9F56"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M839.825 892.685C854.295 902.879 865.41 912.331 870.791 920.202C898.207 960.303 891.203 1127.72 888.829 1213.15C886.93 1281.49 924.984 1365.22 944.248 1398.54C912.06 1422.4 847.613 1494.21 810.416 1610.32C815.818 1574.05 829.509 1525.19 848.944 1485.67C868.75 1445.4 893.626 1416.13 911.241 1391.79C911.179 1391.65 869.072 1295.22 855.381 1231.7C848.967 1201.95 849.719 1177.19 850.735 1152.8C847.106 1127.64 851.352 1052.13 856.874 1005.49C843.476 985.821 840.522 932.81 839.825 892.685Z",
    fill: "#2453C1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M655.063 784.922C655.42 786.213 655.864 787.161 656.405 787.726C667.179 798.975 843.376 880.102 870.791 920.203C875.371 926.902 878.988 937.156 881.829 949.987L856.249 1005.05C837.092 965.128 783.118 923.712 763.083 909.722C731.56 901.344 683.634 857.65 659.473 817.345C652.965 806.489 652.376 795.004 655.063 784.922Z",
    fill: "#2453C1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M672.7 561.699C680.809 571.116 687.641 583.678 682.397 594.45C672.754 614.261 645.632 776.478 656.405 787.726C664.016 795.673 754.174 838.49 816.122 877.081C835.38 907.31 847.774 934.163 833.149 936.761C778.389 946.489 654.793 853.065 630.886 792.26C637.55 752.44 646.323 646.737 662.304 583.212C656.463 561.858 653.429 570.301 666.501 560.53L672.7 561.699Z",
    fill: "#2453C1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.563 1189.68C911.587 1182.78 958.619 1156.92 972.538 1162.63C989.175 1169.46 1032.3 1184.48 1052.15 1203.62C1050.75 1206.24 1049.54 1208.76 1048.61 1211.16C1020.43 1181.44 948.387 1166.56 900.563 1189.68Z",
    fill: "#CBDEEC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M924.583 1035.2C915.59 1036.8 913.742 1039.45 921.684 1044.99C944.918 1061.22 976.334 1065.43 992.071 1062.64C1007.81 1059.84 1036.34 1024.63 1050.73 1001.2C1049.68 1008.34 1038.33 1035.87 1029.89 1053.6C1042.48 1051.36 1072.41 992.708 1068.02 967.979C1042.39 993.404 931.327 1034 924.583 1035.2Z",
    fill: "#CBDEEC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M770.812 771.083C765.488 765.813 728.534 765.87 702.229 783.266C708.197 768.495 746.053 740.382 770.812 771.083Z",
    fill: "#C1DBEC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.136 851.493C748.161 885.306 748.67 864.717 793.698 875.216C827.754 883.157 885.03 898.478 889.682 918.492C894.335 938.506 888.973 1010.21 882.52 1029.45C879.877 1037.33 863.087 1064.6 850.263 1089.67C851.53 1061.16 854.032 1029.5 856.875 1005.49C856.711 1005.25 856.548 1005 856.387 1004.75L856.249 1005.05C843.076 977.599 813.442 949.443 789.7 929.982C752.378 916.095 707.371 884.706 674.136 851.493Z",
    fill: "#C1DBEC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.38 921.26C1181.25 908.981 1194.45 903.402 1202.25 902.498C1192.78 911.132 1209.21 943.016 1218.54 957.528C1212.96 950.556 1199.51 933.54 1190.38 921.26Z",
    fill: "#C1DBEC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850.08 1181.99C875.238 1271.29 947.611 1371.16 951.845 1395C956.492 1421.16 973.221 1459.76 997.334 1456.57C984.597 1461.03 951.208 1450.07 938.244 1426.48C926.977 1405.99 856.951 1525.75 810.084 1612.6C815.242 1576.12 829.098 1526.03 848.944 1485.67C868.749 1445.4 893.626 1416.13 911.24 1391.79C911.179 1391.65 869.072 1295.22 855.381 1231.7C851.486 1213.64 850.236 1197.41 850.08 1181.99Z",
    fill: "#C1DBEC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M995.139 1342.34C976.378 1347.86 974.416 1355.34 969.358 1363.92C957.657 1383.76 959.391 1428.21 966.939 1436.74C974.487 1445.27 989.181 1466.24 1014.78 1452.92C1029.78 1445.12 1043.96 1369.31 1036.57 1356.37C1029.18 1343.42 1008.76 1338.32 995.139 1342.34Z",
    fill: "#FF9F56"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.44 818.327C1322.88 830.786 1348.42 852.027 1362.99 861.874C1361.11 861.543 1358.95 861.013 1356.47 860.25C1355.94 867.924 1351.88 878.849 1345.56 891.516C1348.47 877.782 1350.16 864.744 1347.68 860.166C1343.11 851.763 1319.61 828.772 1308.44 818.327Z",
    fill: "#CBDEEC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M661.318 579.795C688.493 588.104 730.834 599.735 740.707 597.374C740.996 597.284 741.278 597.194 741.551 597.105C741.304 597.209 741.022 597.298 740.707 597.374C726.393 601.804 692.586 605.664 660.814 589.342C661.304 587.259 661.8 585.214 662.304 583.212C661.966 581.976 661.635 580.841 661.318 579.795Z",
    fill: "#CBDEEC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M740.616 691.994C752.168 725.725 771.83 767.045 793.606 766.644C810.431 766.334 826.922 766.222 839.464 766.196C839.814 766.727 840.164 767.261 840.518 767.795C831.377 770.882 807.389 788.706 785.639 783.028C764.108 777.408 745.506 731.269 740.616 691.994Z",
    fill: "#ED8537"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1919_1149",
    x: 425.383,
    y: 233.561,
    width: 1036.52,
    height: 404.919,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.0393,
    result: "effect1_foregroundBlur_1919_1149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1919_1149",
    x: 1109.46,
    y: 463.907,
    width: 356.982,
    height: 733.311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3394,
    result: "effect1_foregroundBlur_1919_1149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1919_1149",
    x1: 973.426,
    y1: 164.023,
    x2: 973.426,
    y2: 1782.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27225D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45236C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1919_1149",
    x1: 973.426,
    y1: 164.023,
    x2: 973.426,
    y2: 1782.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27225D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#351E52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1919_1149",
    x1: 326.522,
    y1: 428.61,
    x2: 326.522,
    y2: 692.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAAFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6487",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1919_1149",
    x1: 1532.03,
    y1: 1353.04,
    x2: 1532.03,
    y2: 1566.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAAFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6487",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1919_1149",
    x1: 1535.38,
    y1: 520.837,
    x2: 1534.74,
    y2: 607.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAAFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6487",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1919_1149",
    x1: 447.203,
    y1: 1001.41,
    x2: 439.279,
    y2: 1456.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAAFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6487",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1919_1149",
    x1: 191.876,
    y1: 1065.57,
    x2: 946.218,
    y2: 1751.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrion);
export default __webpack_public_path__ + "static/media/Orion.043d7129b2e1ce3c9e710cbad11eecd9.svg";
export { ForwardRef as ReactComponent };